import { Template1 } from "./template1";
import { Template2 } from "./template2";

import { Template } from "@/types/template";

export const templateRegistry: Record<string, Template> = {
  default: {
    Component: Template1,
    name: "Classic Receipt",
  },
  // Modern minimalist design
  "01957f8f-28fc-8015-8575-52fb8b426242": {
    Component: Template2,
    name: "Modern Minimalist",
  },
};

export const getTemplate = (templateId: string): Template => {
  return templateRegistry[templateId] || templateRegistry.default;
};
